export default __webpack_public_path__ + "static/media/blueExclamationCrownToLeft.423e150b.svg";